/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Checkboxes_Onlylowestpriceever3Inputs */

const id_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya harga termurah`)
};

const ms_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya harga terendah pernah`)
};

const da_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun laveste pris nogensinde`)
};

const de_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur niedrigster Preis aller Zeiten`)
};

const en_us2_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only lowest price ever`)
};

const es_es2_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo el precio más bajo`)
};

const es_mx2_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo el precio más bajo de siempre`)
};

const fil_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakamababang presyo lang`)
};

const fr_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uniquement le prix le plus bas`)
};

const it_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo prezzo più basso di sempre`)
};

const hu_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csak a valaha volt legalacsonyabb ár`)
};

const nl_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen laagste prijs ooit`)
};

const no_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bare laveste pris noensinne`)
};

const pl_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tylko najniższa cena w historii`)
};

const pt_br2_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas o menor preço de todos os tempos`)
};

const pt_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas o preço mais baixo de sempre`)
};

const ro_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doar cel mai mic preț vreodată`)
};

const fi_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vain alin hinta koskaan`)
};

const sv_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endast lägsta priset någonsin`)
};

const vi_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ giá thấp nhất từ trước đến nay`)
};

const tr_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca en düşük fiyat`)
};

const cs_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pouze nejnižší cena vůbec`)
};

const bg_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Само най-ниска цена`)
};

const ru_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только самая низкая цена`)
};

const uk_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тільки найнижча ціна за весь час`)
};

const ar_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أقل سعر على الإطلاق فقط`)
};

const hi_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल अब तक की सबसे कम कीमत`)
};

const th_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เฉพาะราคาต่ำสุดตลอดกาล`)
};

const ja_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`史上最安値のみ`)
};

const zh_cn2_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅限史上最低价`)
};

const zh_hant1_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`僅限史上最低價`)
};

const ko_search_checkboxes_onlylowestpriceever3 = /** @type {(inputs: Search_Checkboxes_Onlylowestpriceever3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최저 가격만`)
};

/**
* | output |
* | --- |
* | "Only lowest price ever" |
*
* @param {Search_Checkboxes_Onlylowestpriceever3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_checkboxes_onlylowestpriceever3 = /** @type {((inputs?: Search_Checkboxes_Onlylowestpriceever3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Checkboxes_Onlylowestpriceever3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "ms") return ms_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "da") return da_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "de") return de_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "en-US") return en_us2_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "es-ES") return es_es2_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "es-MX") return es_mx2_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "fil") return fil_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "fr") return fr_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "it") return it_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "hu") return hu_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "nl") return nl_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "no") return no_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "pl") return pl_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "pt-BR") return pt_br2_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "pt") return pt_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "ro") return ro_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "fi") return fi_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "sv") return sv_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "vi") return vi_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "tr") return tr_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "cs") return cs_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "bg") return bg_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "ru") return ru_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "uk") return uk_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "ar") return ar_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "hi") return hi_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "th") return th_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "ja") return ja_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "zh-CN") return zh_cn2_search_checkboxes_onlylowestpriceever3(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_checkboxes_onlylowestpriceever3(inputs)
	return ko_search_checkboxes_onlylowestpriceever3(inputs)
});
export { search_checkboxes_onlylowestpriceever3 as "search.checkboxes.onlyLowestPriceEver" }